import React from 'react';
import ReportViewer from "./base/ReportViewer";

const MontantRecevoir = () => {

    return (
        <div style={{ height: "100%" }}>
            <ReportViewer reportName={"Montantrecevoirreport"} />
        </div>
    );
}
export default MontantRecevoir; 
